import { apiClient } from '../../../../helpers/api_helper';

export const getAllKaratData = async (data: object) => {
    try {
        const response = await apiClient.get(`/api/v1/Karat/GetAllKarat`, data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getAllKaratForSelect = async (params?: any) => {
    try {
        let response;
        if(params) {
            response = await apiClient.get(`/api/v1/Karat/GetKaratSelectListByMaterialTyId?materialTypeId=${params}`);
        }
        else {
            response = await apiClient.get(`/api/v1/Karat/GetKaratSelectList`);
        }
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const getKaratById = async (id: any) => {
    try {
        const response = await apiClient.get(`/api/v1/Karat/GetKaratDetailsById?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error);
    }
};

export const createKarat = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Karat/InsertKarat', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const updateKarat = async (data: object) => {
    try {
        const response = await apiClient.post('/api/v1/Karat/UpdateKarat', data);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};

export const deleteKarat = async (id: any) => {
    try {
        const response = await apiClient.delete(`/api/v1/Karat/DeleteKarat?Id=${id}`);
        return response;
    } catch (error: any) {
        throw new Error(error.message);
    }
};